/**
 * Builds the DOM for the OAuth session popup: shows the signed-in user's details
 * and a log-out action. Rendered by {@link OauthSessionPopup}.
 */
export const oauthSessionPopupView = (user) => {
    var _a, _b;
    const name = (_a = user.display_name) === null || _a === void 0 ? void 0 : _a.trim();
    const email = (_b = user.email) === null || _b === void 0 ? void 0 : _b.trim();
    const container = document.createElement('div');
    container.className = 'popup-container oauth-session-popup';
    const closeButton = document.createElement('div');
    closeButton.className = 'overlay-button overlay-button-close will-close';
    closeButton.setAttribute('role', 'button');
    closeButton.setAttribute('tabindex', '0');
    closeButton.setAttribute('aria-label', 'Close');
    closeButton.appendChild(document.createElement('span'));
    const main = document.createElement('div');
    main.className = 'main';
    const title = document.createElement('h2');
    title.className = 'oauth-session-popup-title';
    title.textContent = 'Signed in';
    main.appendChild(title);
    if (name) {
        const nameEl = document.createElement('p');
        nameEl.className = 'oauth-session-popup-name';
        nameEl.textContent = name;
        main.appendChild(nameEl);
    }
    if (email) {
        const emailEl = document.createElement('p');
        emailEl.className = 'oauth-session-popup-email';
        emailEl.textContent = email;
        main.appendChild(emailEl);
    }
    const logoutButton = document.createElement('button');
    logoutButton.type = 'button';
    logoutButton.className = 'oauth-session-popup-logout';
    logoutButton.textContent = 'Log out';
    main.appendChild(logoutButton);
    container.appendChild(closeButton);
    container.appendChild(main);
    return container;
};
